import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from "@tanstack/react-query"
import { guardAppUsage } from "@mimber-client/guards/AppGuard"
import { useServerContext } from "@mimber-client/contexts/ServerContext"
import type { EventWithRelationsDto, ResponseDto } from "@mimber/schema"
import { eventsKeys } from "../events.utils"
import type { UseDuplicateEventOptions } from "./useDuplicateEvent.types"

export const useDuplicateEvent = (
  eventUuid: string,
  options: UseDuplicateEventOptions = {}
): UseMutationResult<ResponseDto<EventWithRelationsDto>, Error, void> => {
  guardAppUsage("mimber-organization", "useDuplicateEvent")

  const { server } = useServerContext()
  const queryClient = useQueryClient()

  return useMutation({
    ...options,
    mutationFn: async () => {
      const response = await server.post<ResponseDto<EventWithRelationsDto>>(
        `events/${eventUuid}/duplicate`,
        {}
      )
      return response.data
    },
    onSuccess: (response, variables, onMutateResult, context) => {
      queryClient.invalidateQueries({
        queryKey: eventsKeys.findAll(),
      })

      if (options?.onSuccess) {
        options.onSuccess(response, variables, onMutateResult, context)
      }
    },
  })
}
